/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadMedication } from './LeadMedication';
import {
    LeadMedicationFromJSON,
    LeadMedicationFromJSONTyped,
    LeadMedicationToJSON,
    LeadMedicationToJSONTyped,
} from './LeadMedication';

/**
 * 
 * @export
 * @interface FindMedicationsForLead200Response
 */
export interface FindMedicationsForLead200Response {
    /**
     * 
     */
    data?: Array<LeadMedication>;
}

/**
 * Check if a given object implements the FindMedicationsForLead200Response interface.
 */
export function instanceOfFindMedicationsForLead200Response(value: object): value is FindMedicationsForLead200Response {
    return true;
}

export function FindMedicationsForLead200ResponseFromJSON(json: any): FindMedicationsForLead200Response {
    return FindMedicationsForLead200ResponseFromJSONTyped(json, false);
}

export function FindMedicationsForLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindMedicationsForLead200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadMedicationFromJSON)),
    };
}

export function FindMedicationsForLead200ResponseToJSON(json: any): FindMedicationsForLead200Response {
    return FindMedicationsForLead200ResponseToJSONTyped(json, false);
}

export function FindMedicationsForLead200ResponseToJSONTyped(value?: FindMedicationsForLead200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadMedicationToJSON)),
    };
}

